import AppContent from './appContent';

export default AppContent;
